import { useAppDispatch } from '../app/hooks';
import LoadingGlobal from '../components/LoadingGlobal/LoadingGlobal';
import { useEffect } from 'react';
import { authLogout, setGatewayLogado, setGovBrLogado } from './authSlice';
import { useHistory } from 'react-router-dom';
import auth from './Auth';
import { getPerfis, getSituacaoCadastroFamilia } from '../features/Perfil/perfilSlice';
import { setLoggingIn } from '../globalSlice';
import config from '../envConfig';

declare const cordova: any;

const SuccessLogin: React.FC<any> = () => {
  const dispatch = useAppDispatch();
  const history = useHistory();

  useEffect(() => {
    const onLoginSuccess = async (token: string) => {
      try {
        await auth.onLoginSuccess(token);
        dispatch(setGatewayLogado(true));
        dispatch(setGovBrLogado(true));
        await auth.delay(500);
        const cpfUser = auth.getUser();
        if (cpfUser){
            await auth.delay(300);

            // Tentar 3 vezes getSituacaoCadastroFamilia
            let result;
            let tentativas = 0;
            const maxTentativas = 5;

            while (tentativas < maxTentativas) {
              result = await dispatch(getSituacaoCadastroFamilia({ cpf: cpfUser, history }));

              // Se tem payload ou erro, sair do loop
              if (result.payload || result.error) {
                if (!result.payload) {
                  console.error('Falha ao carregar dados. Result: ', (result as any).error?.message);
                  const errorMessage = (result as any).error?.message;

                  if(errorMessage && !errorMessage.includes("Sistema parceiro indisponível")) {
                    throw new Error('Falha ao carregar dados da família.');
                  }
                }
                break;
              }

              tentativas++;
              if (tentativas < maxTentativas) {
                await auth.delay(1000);
              }
            }

            await dispatch(getPerfis(cpfUser));

            dispatch(setLoggingIn(false));
            // Aguarda um pouco antes de redirecionar para garantir que o estado foi atualizado
            await auth.delay(300);
            history.replace("/home");
          /* if (config.isCordova) {
              await auth.delay(300);
              window.location.reload();
            }
          */
        } else{
           throw new Error('Falha ao obter CPF usuário logado.');
        }
      } catch (err: unknown) {
        dispatch(setLoggingIn(false));
        console.error('Falha efetuando login', err);
        if (err instanceof Error) {
          alert(err.message);
        } else {
          alert('Erro inesperado efetuando login!')
        }
        dispatch(authLogout({ history }));
       // auth.logoutGovBr();
      }
    };

    const token = auth.extractTokenFromUrlHash(window.location.hash);
    onLoginSuccess(token);
  }, [dispatch, history]);

  return (
    <LoadingGlobal/>
  );
}

export default SuccessLogin;
